import { createFileRoute } from '@tanstack/react-router'
import { HistoryPanel } from '@/components/history/history-panel'

export const Route = createFileRoute('/history/')({
  component: HistoryPanel,
})
